// src/components/GuestConfirmation.tsx
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";

export const GuestConfirmation = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [guest, setGuest] = useState<any>(null);
  const [selected, setSelected] = useState(1);
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (!token) return;
    const fetchGuest = async () => {
      const docRef = doc(db, "guests", token);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setGuest(docSnap.data());
      } else {
        setGuest(null);
      }
    };
    fetchGuest();
  }, [token]);

  const handleConfirm = async () => {
    if (!guest || !token) return;
    const docRef = doc(db, "guests", token);
    await updateDoc(docRef, {
      confirmed: selected,
      hasConfirmed: true,
    });
    setConfirmed(true);
  };

  if (!token) return <p>Token no válido.</p>;
  if (!guest) return <p>Cargando invitado...</p>;
  if (confirmed) return <p>¡Gracias por confirmar, {guest.name}!</p>;

  return (
    <div>
      <h2>Hola, {guest.name}</h2>
      <p>Estás invitado con {guest.invited} pase(s).</p>
      <label>
        ¿Cuántos asistirán?
        <select
          value={selected}
          onChange={(e) => setSelected(parseInt(e.target.value))}
        >
          {Array.from({ length: guest.invited }, (_, i) => (
            <option key={i + 1} value={i + 1}>
              {i + 1}
            </option>
          ))}
        </select>
      </label>
      <br />
      <button onClick={handleConfirm}>Confirmar asistencia</button>
    </div>
  );
};
